import { memoize } from './function'

export const max = (array: unknown[]): number => Math.max.apply(null, array)
export const min = (array: unknown[]): number => Math.min.apply(null, array)

// memoize this
export const isMember = (
  array: unknown[],
  member: unknown,
  fieldSelector = (x) => x,
  memberFieldSelector = (x) => x
): boolean =>
  (array || []).some((x) => fieldSelector(x) === memberFieldSelector(member))

// memoize this
export const selectById = (array: { id: string }[], id: string): { id } =>
  (array || []).find((item) => item && item.id && item.id === id)

export const createArray = memoize((n) => Array.from(Array(n).keys()))

// See https://stackoverflow.com/questions/3978492/javascript-fastest-way-to-duplicate-an-array-slice-vs-for-loop
export const cloneArray = (array: unknown[]): unknown[] =>
  array && Array.isArray(array) ? array.slice(0) : undefined

export const arrayIterator = (
  size: number,
  generator = (x) => x
): unknown[] => {
  const results = []
  for (let i = 0; i < size; i++) {
    results.push(generator(i))
  }
  return results
}

// See https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
export const getUniqueValues = (array: unknown[]): unknown[] =>
  array.filter((v, i, a) => a.indexOf(v) === i)
